import { gql } from 'graphql-tag'

const fileLinkFragment = gql`
  fragment FileLinkFragment on FileLink {
    id
    fileName
    href
    company {
      id
      name
    }
    linkTags {
      id
      name
    }
  }
`

export const fetchFileLinks = gql`
  query FetchFileLinks {
    fileLinks {
      ...FileLinkFragment
    }
  }
  ${fileLinkFragment}
`

export const fetchAokFileLinks = gql`
  query FetchAokFileLinks($companyId: ID) {
    aokFileLinks(companyId: $companyId) {
      ...FileLinkFragment
    }
  }
  ${fileLinkFragment}
`

export const createFileLink = gql`
  mutation CreateFileLink($fileName: String!, $href: String!, $companyId: ID, $linkTagId: ID) {
    createFileLink(fileName: $fileName, href: $href, companyId: $companyId, linkTagId: $linkTagId) {
      ...FileLinkFragment
    }
  }
  ${fileLinkFragment}
`
export const updateFileLink = gql`
  mutation UpdateFileLink($id: ID!, $fileName: String!, $href: String!, $linkTagId: ID) {
    updateFileLink(id: $id, fileName: $fileName, href: $href, linkTagId: $linkTagId) {
      ...FileLinkFragment
    }
  }
  ${fileLinkFragment}
`

export const deleteFileLink = gql`
  mutation DeleteFileLink($id: ID!) {
    deleteFileLink(id: $id)
  }
`
